// --
// -- Routes a visitor can open without an authorized order.
// --
// -- Kept in its own module (not siteMap.tsx) so the api layer can import it
// -- without pulling in the page components, which would be a circular import.
// --

export const PARTSCARE_PATH = `${process.env.REACT_APP_BASE_URL}partscare`

export const publicPaths: string[] = [PARTSCARE_PATH]

export const isPublicPath = (pathname: string): boolean =>
  publicPaths.some((path) => pathname === path || pathname === `${path}/`)
